<p-toast></p-toast>

<div class="root-body"
     [ngClass]="{
    'root-body-sidebar-slim': configService.config.menuMode === 'sidebar' || configService.config.menuMode === 'slim',
    'root-body-sidebar-static': configService.config.menuMode === 'sidebar' && configService.config.sidebarStatic,
    'root-body-horizontal': configService.config.menuMode === 'horizontal'}">

<!--    <p-breadcrumb class="breadcrumb mb-3" [model]="breadcrumbs"></p-breadcrumb>-->

    <drivers-filter *ngIf="visibleFilter"
                    [visibleDriversFilter]="visibleFilter"
                    [filterObj]="filterObj"
                    [driversComponent]="this"
                    (changedVisibleDriversFilterFilterEmit)="changedDisplayFilterEmit($event)"></drivers-filter>

    <driver-detail [_visibleDetail]="visibleDetail"
                   [_driverId]="selectedDriver.Id"
                   [showEditFields]="showEditFields"
                   [menuPermissionActive]="menuPermissionActive"
                   [isActiveDrivers]="isActiveDrivers()"
                   [isCommerceTab]="isCommerceTab"
                   (changedVisibleDetailEmit)="changedVisibleDetailEmit($event)"
                   (showDetails)="showDetails($event)"
                   (showTransactions)="showTransactions($event)"
                   *ngIf="visibleDetail && !visibleProductTransactions && !visibleProductDetails"></driver-detail>
    
    <product-transactions 
        *ngIf="visibleProductTransactions" 
        (goBackToDetails)="showTransactions($event)" 
        [showBack]="true" [riderId]="riderId"
        (showDetails)="showDetails($event)">
    </product-transactions>
    <product-details *ngIf="visibleProductDetails" [commerceId]="commerceId" (goBackToDetails)="showProductDetails($event)"></product-details>

    <suspend-user [userId]="suspendUser.userId" [userName]="suspendUser.userName" [_displayModalSuspend]="displayModalSuspend"
                  (changedDisplayModalSuspendEmit)="changedDisplayModalSuspendEmit($event)"></suspend-user>

    <driver-add *ngIf="showDriverAddSideBar"
                [showDriverAddSideBar]="showDriverAddSideBar"
                [driversComponent]="this"
                (changedShowDriverAddSideBarEmit)="changedShowDriverAddSideBarEmit($event)"></driver-add>

    <drivers-compaign-export-sidebar *ngIf="showDriversCompaignExportSidebar"
                                     [showDriversCompaignExportSidebar]="showDriversCompaignExportSidebar"
                                     [menuHome]="menuHomeEnumActive"
                                     [driverVehicleTypes]="driverVehicleTypes"
                                     [driverServiceTypes]="driverServiceTypes"
                                     [driverCampaign]="driverHeaderSearch.driverCampaign"
                                     (changedShowDriversCompaignExportSidebarEmit)="changedShowDriversCompaignExportSidebarEmit($event)"></drivers-compaign-export-sidebar>

	<p-dialog header="Campaign" [(visible)]="visibleCampaignDialog" [modal]="true" [style]="{ width: '20vw' }" [draggable]="false" [resizable]="false">
        <div class="mt-3 mb-3">
            <div class="flex justify-content-center">
                <p-dropdown [style]="{ 'width': '300px' }"
                            [options]="driverCampaignList" [(ngModel)]="selectedCampaign"
                            optionLabel="name" optionValue="id"
                            [showClear]="true" placeholder="Select a Campaign"></p-dropdown>
            </div>
            <div class="flex flex-wrap gap-5" style="margin: 15px 0px; justify-content: center;" *ngIf="selectedCampaign === driverCampaignTypeEnum.Xpress50Rider4W">
                <div class="flex align-items-center">
                    <p-radioButton name="Morning"
                                   [value]="xpress50IncentiveType.Morning"
                                   [(ngModel)]="selectedXpress50IncentiveType"
                                   inputId="incentiveType1" />
                    <label for="incentiveType1" class="ml-2">
                        AM
                    </label>
                </div>
                <div class="flex align-items-center">
                    <p-radioButton name="Evening"
                                   [value]="xpress50IncentiveType.Evening"
                                   [(ngModel)]="selectedXpress50IncentiveType"
                                   inputId="incentiveType2" />
                    <label for="incentiveType2" class="ml-2">
                        PM
                    </label>
                </div>
            </div>
        </div>

		<ng-template pTemplate="footer">
			<p-button label="Save" icon="pi pi-check" (click)="addToCampaign()"></p-button>
			<p-button label="Delete" icon="pi pi-times"
					  (click)="removeFromCampaign()"
					  styleClass="p-button-secondary" [style]="{ 'margin-left': '.5em' }"></p-button>
		</ng-template>
	</p-dialog>

    <p-dialog
            [modal]="true"
            [closable]="true"
            [draggable]="false"
            [resizable]="false"
            [(visible)]="showInviteDialog"
            [style]="{ width: '650px', height: '355px' }">
        <ng-template pTemplate="header">
            <span class="invite-dialog-header">{{inviteDialogHeader}}</span>
        </ng-template>
        <ng-template pTemplate="body">
            <div *ngIf="importedRowsAlreadyExist" class="">
                <div *ngIf="rowsDetected" class="flex rows-detected transactions-counter bottom-border">
                    <div class="col-2"></div>
                    <div class="col-2">{{rowsDetected}}</div>
                    <div class="col-8">Rows detected</div>
                </div>
                <div *ngIf="rowsUploaded" class="flex bottom-border">
                    <div class="col-2"></div>
                    <div class="col-2">{{rowsUploaded}}</div>
                    <div class="col-8">Rows uploaded</div>
                </div>
                <div *ngIf="rowsAlreadyExisting" class="flex rows-error sidebar-text bottom-border">
                    <div class="col-2">
                        <img class="ml-4" src="../Content/xpress-app/images/error-red-exclamation.svg" width="16px" height="16px" alt="file">
                    </div>
                    <div class="col-2">{{rowsAlreadyExisting}}</div>
                    <div class="col-8">Rows already exist</div>
                </div>
                <div *ngIf="rowsError" class="flex rows-error sidebar-text bottom-border">
                    <div class="col-2">
                        <img class="ml-4" src="../Content/xpress-app/images/error-red-exclamation.svg" width="16px" height="16px" alt="file">
                    </div>
                    <div class="col-2">{{rowsError}}</div>
                    <div class="col-8">Rows error</div>
                </div>
            </div>

            <div *ngIf="(selectedInviteType === InviteType.Single) && !importedRowsAlreadyExist">
                <div class="flex-row stretch">
                    <div>
                        <label class="invite-label">First Name</label>
                        <input type="text" class="mt-2 mb-4 invite-input-width" [(ngModel)]="singleInvitedDriver.FirstName" placeholder="Enter FirstName" pInputText />
                    </div>
                    <div>
                        <label class="invite-label ml-3">Last Name</label>
                        <input type="text" class="mt-2 mb-4 ml-3 invite-input-width" [(ngModel)]="singleInvitedDriver.LastName" placeholder="Enter LastName" pInputText />
                    </div>
                </div>
                <div class="flex-row stretch">
                    <div>
                        <label class="invite-label">Phone Number</label>
<!--                        <p-dropdown [options]="arrayPhonePrefixes" placeholder="Please Select"-->
<!--                                    optionLabel="name" optionValue="value" [(ngModel)]="singleInvitedDriver.PhonePrefix">-->
<!--                        </p-dropdown>-->
                        <input type="text" class="mt-2 invite-input-width" [(ngModel)]="singleInvitedDriver.Phone" placeholder="+00 000 000 0000" pInputText />
                    </div>
                    <div>
                        <label class="invite-label ml-3">Email</label>
                        <input type="text" class="mt-2 ml-3 invite-input-width" [(ngModel)]="singleInvitedDriver.Email" placeholder="Enter Email" pInputText />
                    </div>
                </div>
            </div>
            <div *ngIf="(selectedInviteType === InviteType.Bulk) && !importedRowsAlreadyExist">
                <div class="mt-3 flex">
                    <div>
                        <div class="mt-3 invite-dropzone" [ngClass]="{'error-dropzone': invitedDriversUploadError}" appDnd (fileDropped)="onFileDropped($event)">

                            <label *ngIf="!invitedDriversProgressBar && !invitedDriversUploadError" class="invite-dropfile-label">Drag and Drop your file</label>
                            <label *ngIf="invitedDriversUploadError" class="error-label">
                                <img src="../Content/xpress-app/images/error-red-cross.svg" width="20px" alt="file">
                                <span style="font-weight: 600">Error</span>Invalid Document
                            </label>
                            <input style="display: none" type="file" id="bulkInvite" (change)="fileBrowseHandler($event)">

                            <label *ngIf="!invitedDriversProgressBar && !invitedDriversUploadError" class="btn-invite bulk-invite mt-2" style="border-radius: 28px; padding-top: 10px" for="bulkInvite">Browse File</label>
                            <label *ngIf="invitedDriversUploadError" class="mt-2 btn-invite try-again-btn text-small-bold" for="bulkInvite">Try again</label>
                            <span class="on-dragover invite-dropfile-label">Drop file here to upload...</span>

                            <div *ngIf="invitedDriversProgressBar && invitedDriversProgressBar < 100" class="mb-8 progress-cont">
                                <div class="progress" [ngStyle]="{ width: invitedDriversProgressBar + '%' }"></div>
                                <span class="mb-2 percent-complete text-very-small">{{invitedDriversProgressBar}}% Complete</span>
                                <div class="operator-btn cancel-btn text-small-bold" (click)="cancelUpload()">Cancel</div>
                            </div>

                            <div *ngIf="invitedDriversProgressBar === 100" style="width: 300px">
                                <div class="mb-1 flex justify-content-between">
                                    <img src="../Content/xpress-app/images/CSV-icon.svg" width="24px" alt="file">
                                    <div class="mt-1 common-font file-name">{{file?.name}}</div>
                                    <div class="mt-1 common-font file-name">{{(file?.size/1024).toPrecision(5)}} KB</div>
                                    <img src="Content/xpress-app/images/operator/signup/remove-upload.svg" class="delete" alt="file" (click)="deleteUpload()">
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            <div *ngIf="!importedRowsAlreadyExist" class="title-float-right mt-4" [ngClass]="{'invite-btn-inactive': isInviteBtnInactive()}" (click)="sendInvite()">
                <img class="btn-icon" style="cursor: pointer" src="Content/xpress-app/images/send-invite.svg" alt='' height="14" width="14">
                <div pRipple class="btn-invite bulk-invite" style="width: 90px; padding-top: 9px">
                    <span class="ml-3">Invite</span>
                </div>
            </div>

            <div *ngIf="importedRowsAlreadyExist" class="flex title-float-right mt-4">
                <div pRipple class="btn-invite single-invite mr-4" [ngClass]="{'invite-btn-inactive': loading}" (click)="overrideInvitedRiders()" style="width: 140px; padding-top: 9px">Override Existing</div>
                <div pRipple class="btn-invite bulk-invite" (click)="downloadError()" style="width: 140px; padding-top: 9px">Download Error</div>
            </div>
        </ng-template>
    </p-dialog>

    <ng-container *ngIf="!visibleDetail">
        <div class="cards">
            <card *ngFor="let card of cards; let i = index;" 
                  [header]="card.Header" 
                  [amount]="card.Amount" 
                  [subAmount]="card.SubAmount" 
                  [lastUpdate]="card.LastUpdate">
            </card>
        </div>
    </ng-container>

    <div *ngIf="!visibleDetail" class="card">
        <div class="onboarding-head">
            <div class="onboarding-head-fleft">
                <div class="head-title mt-3 ml-1">Drivers</div>
            </div>
            <div class="flex flex-row onboarding-head-right">
                <div *ngIf="appData.xpressUserRoleId === XpressUserRoleEnum.Operator" pRipple class="btn-invite single-invite mr-4" (click)="singleInvite()">Single Invite</div>
                <div *ngIf="appData.xpressUserRoleId === XpressUserRoleEnum.Operator" pRipple class="btn-invite bulk-invite mr-4" (click)="bulkInvite()">Bulk Invite</div>
                <xpress-calendar [initialValue]="XpressCalendarEnum.Today" [marginLeft]="'-790px'" (generateHandler)="dateFilterChange($event)"></xpress-calendar>
                <div class="ml-3">
                    <column-selector #columnSelector
                                     [defaultColumns]="defaultCols"
                                     (selectedColumnsChange)="onSelectedColumnsChange($event)"
                                     [tableName]="tableName"
                                     [(selectedColumns)]="cols">
                    </column-selector>
                </div>
                <p-button *ngIf="isTaxiOrConnexDriversBackOffice()" icon="pi pi-plus-circle" label="Create new Account" styleClass="btn-darkblue" class="ml-4" (click)="openDriverAddSideBar()"></p-button>
            </div>
        </div>

        <!-- Table -->
        <p-table #xpressUsersGrid
                 [columns]="cols"
                 [value]="riders"
                 [lazy]="true"
                 responsiveLayout="scroll"
                 dataKey="Id"
                 selectionMode="single"
                 (onLazyLoad)="handleLazyLoad($event)"
                 [showFirstLastIcon]="false"
                 [paginator]="true"
                 [(first)]="first"
                 [rows]="rowsPerPage"
                 [selection]="selectedDriver"
                 [totalRecords]="totalRecords"
                 [resizableColumns]="true"
                 [columnResizeMode]="'expand'"
                 [autoLayout]="true"
                 [styleClass]="'p-datatable-gridlines'"
                 [scrollable]="true"
                 [scrollHeight]="'flex'"
                 [loading]="loading"
                 [style]="{height: 'calc(66vh)'}"
                 [attr.data-testid]="componentTestId + '-grid'">
            <ng-template pTemplate="caption">
                <!--empty caption necessary for margin without scroll-->
            </ng-template>
            <ng-template pTemplate="header">
                <tr>
                    <th *ngFor="let col of cols"
                        [pSortableColumn]="col.field"
                        [pSortableColumnDisabled]="col.disableSort"
                        pResizableColumn
                        [style.width]="col.width">
                        {{col.header}}
                        <p-sortIcon class="column-sorticon" [field]="col.field"></p-sortIcon>
                    </th>
                    <!-- <th>Action</th> -->
                </tr>
                <tr>
                    <ng-container *ngFor="let item of cols">
                        <th class="overflow-unset">
                            <ng-container *ngIf="item.fieldType === fieldTypeEnum.Inputs">
                                <input [disabled]="item.disabled" type="text" pInputText placeholder="{{item.placeholder}}" [(ngModel)]="driverHeaderSearch[item.model]"
                                       (input)="handleHeaderFilterChange(item.field, $event)" />
                            </ng-container>
                            <ng-container *ngIf="item.fieldType === fieldTypeEnum.InputNumber">
                                <p-inputNumber inputId="integeronly" placeholder="{{item.placeholder}}" [(ngModel)]="driverHeaderSearch[item.model]"
                                               (ngModelChange)="handleHeaderFilterChange(item.field, $event)"> </p-inputNumber>
                            </ng-container>
                            <ng-container *ngIf="item.fieldType === fieldTypeEnum.Dropdown">
                                <ng-container *ngIf="item.take === 'obj'; else dropdown">
                                    <p-dropdown [options]="item.options" placeholder="{{item.placeholder}}"
                                                optionLabel="name" [(ngModel)]="driverHeaderSearch[item.model]"
                                                (ngModelChange)="handleHeaderFilterChange(item.field, $event)"></p-dropdown>
                                </ng-container>
                                <ng-template #dropdown>
                                    <p-dropdown [options]="item.options" placeholder="{{item.placeholder}}"
                                                optionLabel="name" optionValue="value" [(ngModel)]="driverHeaderSearch[item.model]"
                                                (ngModelChange)="handleHeaderFilterChange(item.field, $event)"></p-dropdown>
                                </ng-template>
                            </ng-container>
                            <ng-container *ngIf="item.fieldType === fieldTypeEnum.Calendar">
                                <p-calendar [(ngModel)]="driverHeaderSearch[item.model]"
                                            [showIcon]="true"
                                            placeholder="{{item.placeholder}}"
                                            dateFormat="dd M yy"
                                            (ngModelChange)="handleHeaderFilterChange(item.field, $event)" />
                            </ng-container>
                        </th>
                    </ng-container>
                </tr>
            </ng-template>

            <ng-template pTemplate="body" let-rider let-columns="columns">
                <tr>
                    <td class="ui-resizable-column" *ngFor="let col of columns; let i = index" [pSelectableRow]="rider" (click)="handleShowDriverInfo(rider)" [attr.data-testid]="componentTestId + '-grid-cell-' + i">
                        <ng-container *ngIf="col.field === 'Phone'">
                            <span *ngIf="isLGUAdmin">{{rider[col.field] | phoneMask:'*':3:2 }}</span>
                            <span *ngIf="!isLGUAdmin">{{rider[col.field] }}</span>
                        </ng-container>
                        <ng-container *ngIf="col.field === 'AcceptanceRate'">
                            <span *ngIf="rider[col.field] === '-'">{{rider[col.field]}}</span>
                            <span *ngIf="rider[col.field] >= 90">{{rider[col.field]}}</span>
                            <span *ngIf="rider[col.field] < 70" class="red">{{rider[col.field]}}</span>
                            <span *ngIf="rider[col.field] >= 70 && rider[col.field] < 90" class="orange">{{rider[col.field]}}</span>
                        </ng-container>
                        <ng-container *ngIf="col.field === 'Rating'">
                            <img *ngIf="rider.Status !== 'Invited'" src="../Content/xpress-app/images/stars{{rider[col.field]}}.png" width="148" />
                            <span *ngIf="rider.Status === 'Invited'">- </span>
                        </ng-container>
                        <ng-container *ngIf="col.field === 'Status'">
                            <div class="status" [ngStyle]="getStatusStyles(rider[col.field])">{{rider[col.field]}}</div>
                        </ng-container>
                        <ng-container *ngIf="col.field !== 'Rating' && col.field !== 'AcceptanceRate' && col.field !== 'Status' && col.field !== 'Phone'">
                            {{rider[col.field]}}
                        </ng-container>
                    </td>
                </tr>
            </ng-template>
            <ng-template pTemplate="paginatorleft" let-state>
                <div *ngIf="riders.length > 0" style="padding-left: 10px">
                    Showing {{first + 1}} to {{first + riders.length}} of {{totalRecords}} entries
                </div>
            </ng-template>
        </p-table>

        <div class="empty-drivers-block" *ngIf="!riders || riders.length === 0">
            <img class="no-drivers-yet" src="Content/xpress-app/images/noDriversYet.png" alt=''>
            <p-dropdown *ngIf="appData.xpressUserRoleId === XpressUserRoleEnum.Operator" #invitesDropdown [options]="inviteTypesList" [(ngModel)]="selectedInviteType"
                        optionLabel="name" optionValue="value" class="invite mt-2 mr-3 ml-8" placeholder="">
                <ng-template pTemplate="selectedItem" let-selectedInviteType>
                    <div class="dropdown-font font-500 dropdown-selected-item"> + Invite Drivers</div>
                </ng-template>
                <ng-template pTemplate="item" let-item>
                    <div class="dropdown-font font-500 dropdown-item" (click)="onSelectInviteType(item.value)">{{ item.name }}</div>
                </ng-template>
            </p-dropdown>
        </div>
    </div>
</div>
<p-dialog header="Remove Rider" [(visible)]="showRemoveRiderPopup" [modal]="true" [style]="{width: '400px'}"
          [draggable]="false" [resizable]="false">
    <p class="m-0">
        Do you really want to delete rider {{selectedRider ? selectedRider.UserName : ""}}?<br>
        Warning: This action cannot be undone!
    </p>
    <ng-template pTemplate="footer">
        <p-button icon="pi pi-times" (click)="showRemoveRiderPopup=false" label="Cancel" styleClass="p-button-text"></p-button>
        <p-button icon="pi pi-trash" [disabled]="loading" (click)="removeRider()" label="Remove" styleClass="p-button-text"></p-button>
    </ng-template>
</p-dialog>
